import React from 'react';
import {CommonList} from '../Common/List';
import {getFields} from './Common';
import {autoCompleteFilter, inputFilter} from '../Filters';
import {PROVIDER} from '../../resources';
import {withStyles} from '@material-ui/core/styles';

export const SiteList = withStyles({autocompleteInput: {minWidth: 400}})(props => (
  <CommonList
    {...props}
    bulkActionButtons={false}
    fields={getFields()}
    filters={[
      key =>
        inputFilter({
          alwaysOn: true,
          key,
          fullWidth: true,
          label: 'Street name or city',
          source: 'name',
        }),
      key =>
        autoCompleteFilter({
          children: {
            optionText: 'name',
          },
          classes: props.classes.autocompleteInput,
          key,
          label: 'Company',
          name: PROVIDER.COMPANIES,
          reference: PROVIDER.COMPANIES,
          source: 'company.id',
        }),
    ]}
    show
  />
));
